import api from "./api";

export const rsvpService = {
  async getInfo(token) {
    const res = await api.get(`/api/rsvp/info/${token}`);
    return res.data;
  },

  async confirm({ token, status, guestCount = null, mealPreference = null }) {
    const res = await api.post("/api/rsvp/confirm", {
      token,
      status,
      guest_count: guestCount,
      meal_preference: mealPreference,
    });
    return res.data;
  },

  async createLinks({ weddingId, guestIds }) {
    const res = await api.post("/api/rsvp/links", {
      wedding_id: weddingId,
      guest_ids: guestIds,
    });
    return res.data;
  },
};


